import { createCSVRow, generateCSVHeaders } from '../utils/csvContentUtils';

interface KeywordItem {
  keyword?: string;
  volume?: number | string;
  difficulty?: number | string;
  cpc?: number | string;
  intent?: string;
  question?: string;
  [key: string]: unknown;
}

interface KeywordData {
  data: KeywordItem[];
}

/**
 * Generate CSV content for regular keyword data
 */
export const generateKeywordsCSV = (data: KeywordData): string => {
  console.log("[csvKeywordGenerator] Generating keyword CSV with data:", 
    data.data.length, "rows");
  
  // Log sample data to debug
  if (data.data.length > 0) {
    console.log("[csvKeywordGenerator] Sample data fields:", 
      Object.keys(data.data[0]).join(", "));
    console.log("[csvKeywordGenerator] First item:", 
      JSON.stringify(data.data[0], null, 2));
  }

  // Determine if we're dealing with question data
  const hasQuestions = data.data.length > 0 && 'question' in data.data[0];
  
  // Create headers for regular keywords - ensure all important fields are included
  const baseHeaders = ["Keyword", "Volume", "Difficulty", "CPC ($)", "Intent"];
  
  // For question data, we don't need both Question and Keyword columns since they're identical
  const headers = hasQuestions 
    ? ["Question", "Volume", "Difficulty", "CPC ($)", "Intent"] // Remove Keyword for question data
    : baseHeaders;
    
  let csvContent = generateCSVHeaders(headers);
  
  // Add data rows - ensuring each field is properly formatted
  data.data.forEach((item: KeywordItem) => {
    // Format CPC as currency if it's a number
    const formattedCPC = typeof item.cpc === 'number' 
      ? `$${item.cpc.toFixed(2)}` 
      : item.cpc || '';
    
    // Format volume as number with commas
    const formattedVolume = typeof item.volume === 'number'
      ? item.volume.toLocaleString()
      : item.volume || '';
    
    // Build the row values
    if (hasQuestions) {
      // For question data, use question instead of keyword and don't include both
      const row = [
        item.question || '',
        formattedVolume,
        item.difficulty || '',
        formattedCPC,
        item.intent || ''
      ];
      csvContent += createCSVRow(row);
    } else {
      // For regular keyword data
      const row = [
        item.keyword || '',
        formattedVolume,
        item.difficulty || '',
        formattedCPC,
        item.intent || ''
      ];
      csvContent += createCSVRow(row);
    }
  });
  
  return csvContent;
};
